/**
 * dragslideshow.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2014, Codrops
 * http://www.codrops.com
 */
;( function( window ) {
	
	'use strict';
	
	var docElem = window.document.documentElement,
		transEndEventNames = {
			'WebkitTransition': 'webkitTransitionEnd',
			'MozTransition': 'transitionend',
			'OTransition': 'oTransitionEnd',
			'msTransition': 'MSTransitionEnd',
			'transition': 'transitionend'
		},
		transEndEventName = transEndEventNames[ Modernizr.prefixed( 'transition' ) ],
		support = { transitions : Modernizr.csstransitions };

	/**
	 * gets the viewport width and height
	 * based on http://responsejs.com/labs/dimensions/
	 */
	function getViewport( axis ) {
		var client, inner;
		if( axis === 'x' ) {
			client = docElem['clientWidth'];
			inner = window['innerWidth'];
		}
		else if( axis === 'y' ) {
			client = docElem['clientHeight'];
			inner = window['innerHeight'];
		}
		
		return client < inner ? inner : client;
	}

	/**
	 * extend obj function
	 */
	function extend( a, b ) {
		for( var key in b ) {
			if( b.hasOwnProperty( key ) ) {
				a[key] = b[key];
			}
		}
		return a;
	}

	/**
	 * DragSlideshow function
	 */
	function DragSlideshow( el, options ) {
		this.el = el;
		this.options = extend( {}, this.options );
		extend( this.options, options );
		this._init();
	}

	/**
	 * DragSlideshow options
	 */
	DragSlideshow.prototype.options = {
		perspective : '1200',
		slideshowRatio : 0.3, // between: 0,1
		onToggle : function() { return false; },
		onToggleContent : function() { return false; },
		onToggleContentComplete : function() {return false; }
	};

	/**
	 * init function
	 * initialize and cache some vars
	 */
	DragSlideshow.prototype._init = function() {
		var self = this;

		// status
		this.isFullscreen = true;

		this.isSliding = false;
		this.isAnimating = false;

		//Initial content state
		if(jQuery('#timeline').hasClass('show-content')){
			this.isContent = true;
		}else{
			this.isContent = false;
			classie.add( jQuery('body')[0], 'timeline-visible' );
			TweenLite.to(jQuery('.page-content'), 0, {opacity:0, delay:0});
		}
		
		// the images wrapper element
		this.imgDragger = this.el.querySelector( 'section.dragdealer' );
		
		// the moving element inside the images wrapper
		this.handle = this.imgDragger.querySelector( 'div.timeline-handle' );


		this.contentSwitch  = document.getElementById( 'timeline-navigation' ).querySelector( '.timeline-content-switch' );
		
		// the slides
		this.slides = [].slice.call( this.handle.children );
		
		// total number of slides
		this.slidesCount = this.slides.length;
		
		if( this.slidesCount < 1 ) return;

		// current
		this.current = 0;

		for (var i = this.slides.length - 1; i >= 0; i--) {
			if(classie.has(this.slides[i],'current')){
				this.current = i;
			}
		};

		// cache options slideshowRatio (needed for window resize)
		this.slideshowRatio = this.options.slideshowRatio;

		// set the width of the handle : total slides * 100%
		this.handle.style.width = this.slidesCount * 100 + '%';
		
		// set the width of each slide to 100%/total slides
		this.slides.forEach( function( slide ) {
			slide.style.width = 100 / self.slidesCount + '%';
		} );
		
		// initialize the DragDealer plugin
		this._initDragDealer();

		// set perspective value to the main element
		this.el.style.WebkitPerspective = this.options.perspective + 'px';
		this.el.style.perspective = this.options.perspective + 'px';

		// init events
		this._initEvents();
	};

	DragSlideshow.prototype.isCurrentlySliding = function(){
		return this.isSliding;
	}

	DragSlideshow.prototype.isTimelineView = function(){
		return this.isContent;
	}

	/**
	 * initialize the events
	 */
	DragSlideshow.prototype._initEvents = function() {
		var self = this;
		
		this.slides.forEach( function( slide ) {
			// clicking the slides when not in isFullscreen mode
			slide.addEventListener( 'click', function() {
				if( self.isFullscreen || self.dd.activity || self.isAnimating ) return false;
				
				if( self.slides.indexOf( slide ) === self.current ) {
					self.toggle();
				}
				else {
					self.isSliding = true;
					self.dd.setStep( self.slides.indexOf( slide ) + 1 );
				}
			} );
		} );

		// keyboard navigation events
		document.addEventListener( 'keydown', function( ev ) {
			var keyCode = ev.keyCode || ev.which;

			if(!self.isContent ) {
				switch (keyCode) {
					// right and left keys
					case 37:
						ev.preventDefault();
						if(!self.dd.disabled && !self.isAnimating){
							self.isSliding = true;
							self.dd.setStep( self.current );
						}
						break;
					case 39:
						ev.preventDefault();
						if(!self.dd.disabled && !self.isAnimating){
							self.isSliding = true;
							self.dd.setStep( self.current + 2 );
						}
						break;
				}
			}
		});

		jQuery('body').off('toggleContent').on('toggleContent',function(){
			self._toggleContent();
		});

		jQuery('body').off('timelineZoomIn').on('timelineZoomIn',function(ev){
			self.toggle(ev);
		});

		jQuery('body').off('timelineZoomOut').on('timelineZoomOut',function(ev){
			self.toggle(ev);
		});

		jQuery('body').off('enableInteractions').on('enableInteractions',function(ev){
			self.dd.enable();
		});

		jQuery('body').off('disableInteractions').on('disableInteractions',function(ev){
			self.dd.disable();
		});

		jQuery('body').off('moveToSlideWithIndex').on('moveToSlideWithIndex',function(ev,slideIndex){
			if(!self.isAnimating){
				self.isSliding = true;
				self.dd.setStep(slideIndex);
			}
		});
	};

	/**
	 * show/hide content
	 */
	DragSlideshow.prototype._toggleContent = function( ) {
		if( this.isAnimating || this.isFullscreen === false) {
			return false;
		}
		var self = this;
		this.isAnimating = true;

		var onEndTransitionFn = function( ev ) {
			if( support.transitions ) {
				if( ev.propertyName.indexOf( 'transform' ) === -1 || ev.target !== this ) return;
				this.removeEventListener( transEndEventName, onEndTransitionFn );
			}
			
			self.isContent = !self.isContent;
			self.isAnimating = false;
			// callback
			$('body').trigger('timelineToggleComplete');
			self.options.onToggleContentComplete();
		};

		// callback
		this.options.onToggleContent();
		
		if( this.isContent ) {
			// enable the dragdealer
			jQuery("html,body").animate({ scrollTop: 0 }, "fast",function(){
				self.dd.enable();
				classie.remove( self.el, 'show-content' );
				classie.add( jQuery('body')[0], 'timeline-visible' );
				jQuery(self.contentSwitch).attr('href', '/'+jQuery(self.slides[self.current || 0 ]).data('url'));
				jQuery(self.contentSwitch).attr('data-vc-url', jQuery(self.slides[self.current || 0 ]).data('url'));

				TweenLite.to(jQuery('.page-content'), 0.25, {opacity:0});
			});
		}
		else {
			// before: scroll all the content up
			
			// disable the dragdealer
			this.dd.disable();
			classie.remove( jQuery('body')[0], 'timeline-visible' );
			classie.add( this.el, 'show-content' );
			jQuery(this.contentSwitch).attr('href', '/tijdlijn/');
			jQuery(this.contentSwitch).attr('data-vc-url', 'tijdlijn/');

			TweenLite.to(jQuery('.page-content'), 0.25, {opacity:1, delay:0.7});
		}

		if( support.transitions ) {
			this.el.addEventListener( transEndEventName, onEndTransitionFn );
		}
		else {
			onEndTransitionFn();
		}
	};

	/**
	 * initialize the Dragdealer plugin
	 */
	DragSlideshow.prototype._initDragDealer = function() {
		var self = this;
		this.dd = new Dragdealer( this.imgDragger, {
			handleClass:'timeline-handle',
			steps: self.slidesCount,
			speed: 0.2,
			loose: true,
			no3dtransforms: this.options.no3dtransforms,
			callback: function( x, y ) {
				self._navigate( x, y );
			},
			animready: function( x, y ) {
				self._animReady( x, y );
			}
		});
		this.dd.setStep(this.current+1,0,true);
		if(this.isContent){
			jQuery(this.contentSwitch).attr('href', '/tijdlijn/');
		}
	};

	/**
	 * DragDealer plugin callback: update current value
	 */
	DragSlideshow.prototype._navigate = function( x, y ) {
		var self = this;

		// add class "current" to the current slide / remove that same class from the old current slide
		classie.remove( this.slides[ this.current || 0 ], 'current' );
		this.previousSlide = this.current;
		this.current = this.dd.getStep()[0] - 1;
		classie.add( this.slides[ this.current ], 'current' );

		var hideRightArrow = (this.current == this.slidesCount - 1 || this.current == 0);
		var hideLeftArrow = (this.current <= 1);

		jQuery('body').trigger('timelineSlided',this.current);

		if( hideRightArrow || hideLeftArrow){
			if(hideLeftArrow){
				$('.timeline-arrow-navigation-arrow-previous').stop().fadeOut('fast');
			}else{
				$('.timeline-arrow-navigation-arrow-previous').stop().fadeIn('fast');
			}
			if(hideRightArrow){
				$('.timeline-arrow-navigation-arrow-next').stop().fadeOut('fast');
			}else{
				$('.timeline-arrow-navigation-arrow-next').stop().fadeIn('fast');
			}
		}else{
			$('.timeline-arrow-navigation-arrow-next, .timeline-arrow-navigation-arrow-previous').stop().fadeIn('fast');
		}
		jQuery(this.contentSwitch).attr('href', '/'+jQuery(this.slides[this.current || 0 ]).data('url'));
		jQuery(this.contentSwitch).attr('data-vc-url', jQuery(this.slides[this.current || 0 ]).data('url'));
		jQuery(this.contentSwitch).attr('data-vc-id', jQuery(this.slides[this.current || 0 ]).data('id'));
		jQuery(this.contentSwitch).attr('data-vc-type', jQuery(this.slides[this.current || 0 ]).data('type'));

		if(this.previousSlide != this.current){
			//Push GAevent for Timeline slidetoggle
			dataLayer.push({'event':'GAevent', 'eventCategory':'Timeline', 'eventAction':'Toggle slides', 'eventLabel':(this.previousSlide < this.current ? 'Next slide' : 'Previous slide') });
		}
	};

	/**
	 * DragDealer plugin callback: animation is ready
	 */
	DragSlideshow.prototype._animReady = function( x, y ) {
		var self = this;
		this.isSliding = false;
		$('body').trigger('timelineStoppedSliding');
	};

	/**
	 * Go to next slide
	 */
	DragSlideshow.prototype.next = function() {
		if(!this.isAnimating){
			self.isSliding = true;
			this.dd.setStep( this.current + 2 );
		}
	};

	/**
	 * Go to next slide
	 */
	DragSlideshow.prototype.previous = function() {
		if(!this.isAnimating){
			self.isSliding = true;
			this.dd.setStep( this.current );
		}
	};

	/**
	 * toggle between fullscreen and minimized slideshow
	 */
	DragSlideshow.prototype.toggle = function(ev) {
		if( this.isAnimating ) {
			return false;
		}

		if(typeof ev != 'undefined' && ev.hasOwnProperty('type') && ev.type == 'timelineZoomOut' && !this.isFullscreen){
			return false;
		}

		if(typeof ev != 'undefined' && ev.hasOwnProperty('type') && ev.type == 'timelineZoomIn' && this.isFullscreen){
			return false;
		}

		var self = this,
			p = this.options.perspective,
			r = this.options.slideshowRatio,
			zAxisVal = this.isFullscreen ? p - ( p / r ) : p - p * r;

		this.isAnimating = true;

		// add preserve-3d to the slides (seems to fix a rendering problem in firefox)
		this._preserve3dSlides( true );
		
		// callback
		this.options.onToggle();

		classie.remove( this.el, this.isFullscreen ? 'switch-max' : 'switch-min' );
		classie.add( this.el, this.isFullscreen ? 'switch-min' : 'switch-max' );

		$("body").trigger( "timelineZoomToggle", [ !self.isFullscreen ] );

		this.imgDragger.style.WebkitTransform = 'translate3d( -50%, '+(self.isFullscreen ? '-125%' : '-50%')+', ' + zAxisVal + 'px )';
		this.imgDragger.style.transform = 'translate3d( -50%, '+(self.isFullscreen ? '-125%' : '-50%')+', ' + zAxisVal + 'px )';

		var onEndTransitionFn = function( ev ) {
			if( support.transitions ) {
				if( ev.propertyName.indexOf( 'transform' ) === -1 ) return;
				this.removeEventListener( transEndEventName, onEndTransitionFn );
			}

			if( !self.isFullscreen ) {
				// remove preserve-3d to the slides (seems to fix a rendering problem in firefox)
				self._preserve3dSlides();
			}

			// replace class "img-dragger-large" with "timeline-img-dragger-small"
			classie.remove( this, self.isFullscreen ? 'timeline-img-dragger-large' : 'timeline-img-dragger-small' );
			classie.add( this, self.isFullscreen ? 'timeline-img-dragger-small' : 'timeline-img-dragger-large' );

			// reset transforms and set width & height
			self.imgDragger.style.WebkitTransform = 'translate3d( -50%, '+(self.isFullscreen ? '-125%' : '-50%')+', 0px )';
			self.imgDragger.style.transform = 'translate3d( -50%, '+(self.isFullscreen ? '-125%' : '-50%')+', 0px )';
			this.style.width = self.isFullscreen ? self.options.slideshowRatio * 100 + '%' : '100%';
			this.style.height = self.isFullscreen ? self.options.slideshowRatio * 100 + '%' : '100%';
			// reinstatiate the dragger with the "reflow" method
			self.dd.reflow();

			// change status
			self.isFullscreen = !self.isFullscreen;
			
			self.isAnimating = false;
		};

		if( support.transitions ) {
			this.imgDragger.addEventListener( transEndEventName, onEndTransitionFn );
		}
		else {
			onEndTransitionFn();
		}
	};

	/**
	 * add/remove preserve-3d to the slides (seems to fix a rendering problem in firefox)
	 */
	DragSlideshow.prototype._preserve3dSlides = function( add ) {
		this.slides.forEach( function( slide ) {
			slide.style.transformStyle = add ? 'preserve-3d' : '';
		});
	};

	/**
	 * add to global namespace
	 */
	window.DragSlideshow = DragSlideshow;

} )( window );